export interface SubMenuItem {
  title: string;
  path: string;
  permission?: string;
}

export interface MenuItem {
  title: string;
  path?: string;
  icon?: string;
  submenu?: SubMenuItem[];
  permission?: string;
}

export const carrierMenuItems: MenuItem[] = [
  {
    title: "Cadastros",
    icon: "Folder",
    submenu: [
      { title: "Veículos", path: "/transportadora/cadastros/veiculos", permission: "veiculos" },
    ],
  },
  {
    title: "Operações no Porto",
    icon: "Truck",
    submenu: [
      { title: "Agendada", path: "/transportadora/operacoes_porto/agendada", permission: "agendada" },
      { title: "Carrossel", path: "/transportadora/operacoes_porto/carrossel", permission: "carrossel" },
    ],
  },
  {
    title: "Operações no Pátio",
    icon: "Truck",
    submenu: [
      { title: "Triagens", path: "/transportadora/operacoes_patio/triagens", permission: "triagens" },
    ],
  },
  {
    title: "Financeiro",
    icon: "DollarSign",
    submenu: [
      { title: "Faturas", path: "/transportadora/financeiro/faturas", permission: "faturas" },
    ],
  },
];

export const menuItems: MenuItem[] = [
  {
    title: "Cadastros",
    icon: "Folder",
    submenu: [
      { title: "Terminais", path: "/patio/cadastros/terminais", permission: "terminais" },
      { title: "Proprietários de Carga", path: "/patio/cadastros/proprietarios_carga", permission: "proprietarios_carga" },
      { title: "Transportadoras", path: "/patio/cadastros/transportadoras", permission: "transportadoras" },
      { title: "Motoristas", path: "/patio/cadastros/motoristas", permission: "motoristas" },
      { title: "Veículos", path: "/patio/cadastros/veiculos", permission: "veiculos" },
      { title: "Mensalista", path: "/patio/cadastros/mensalistas", permission: "mensalistas" },
    ],
  },
  {
    title: "Comercial",
    icon: "Store",
    submenu: [
      { title: "Bumerangue", path: "/patio/comercial/bumerangue", permission: "bumerangue" },
      { title: "Custo Estadia", path: "/patio/comercial/custo_estadia", permission: "custo_estadia" },
      { title: "Custo Triagem", path: "/patio/comercial/custo_triagem", permission: "custo_triagem" },
    ],
  },
  {
    title: "Operações no Porto",
    icon: "Truck",
    submenu: [
      { title: "Agendada", path: "/patio/operacoes_porto/agendada", permission: "agendada" },
      { title: "Carrossel", path: "/patio/operacoes_porto/carrossel", permission: "carrossel" },
    ],
  },
  {
    title: "Operações no Pátio",
    icon: "Truck",
    submenu: [
      { title: "Entrada/Saída Veículos", path: "/patio/operacoes_patio/entrada_saida_veiculos", permission: "entrada_saida_veiculos" },
      { title: "Serviços", path: "/patio/operacoes_patio/servicos", permission: "servicos" },
      { title: "Faturamento", path: "/patio/operacoes_patio/faturamento", permission: "faturamento" },
      { title: "Guichês", path: "/patio/operacoes_patio/guiches", permission: "guiches" },
      { title: "Cancelas", path: "/patio/operacoes_patio/cancelas", permission: "cancelas" },
      { title: "Triagens", path: "/patio/operacoes_patio/triagens", permission: "triagens" },
      { title: "Cancela Manual", path: "/patio/operacoes_patio/cancela_manual", permission: "cancela_manual" },
      { title: "Painel de Chamadas", path: "/patio/operacoes_patio/painel_chamadas", permission: "painel_chamadas" },
    ],
  },
  {
    title: "Operação SPE SUAPE",
    icon: "Truck",
    submenu: [
      { title: "Agendada SPE", path: "/patio/operacoes_porto/agendada_spe", permission: "agendada_spe" },
      { title: "Entrada/Saída Veículos SPE", path: "/patio/operacoes_patio/entrada_saida_veiculos_spe", permission: "entrada_saida_veiculos_spe" },
      { title: "Cancela Manual SPE", path: "/patio/operacoes_patio/cancela_manual_spe", permission: "cancela_manual_spe" },
      { title: "Triagens SPE", path: "/patio/operacoes_patio/spe", permission: "operacao_patio_spe" },
    ],
  },
  {
    title: "Financeiro",
    icon: "DollarSign",
    submenu: [
      { title: "Caixa Geral", path: "/patio/financeiro/caixa_geral", permission: "caixa_geral" },
      { title: "Movimentações", path: "/patio/financeiro/movimentacoes", permission: "movimentacoes" },
      { title: "Faturas", path: "/patio/financeiro/faturas", permission: "faturas" },
      { title: "Faturamento", path: "/patio/financeiro/faturamento", permission: "faturamento_financeiro" },
    ],
  },
  {
    title: "Auditoria",
    icon: "ShieldCheck",
    submenu: [
      { title: "Entrada Veículos", path: "/patio/auditoria/entrada_veiculos", permission: "auditoria_entrada_veiculos" },
      { title: "Pátio Porto", path: "/patio/auditoria/patio_porto", permission: "api_patio_porto" },
      { title: "Terminal Pátio", path: "/patio/auditoria/terminal_patio", permission: "auditoria_terminal_patio" },
    ],
  },
  {
    title: "Configurações",
    icon: "Settings",
    submenu: [
      { title: "Usuários", path: "/patio/configuracoes/usuarios", permission: "usuarios" },
      { title: "Grupos", path: "/patio/configuracoes/grupos", permission: "grupos" },
      { title: "Parâmetros", path: "/patio/configuracoes/parametros", permission: "parametros" },
      { title: "Tipo Serviço", path: "/patio/configuracoes/tipos_servicos", permission: "tipos_servico" },
      { title: "Tipo de Carga SPE", path: "/patio/configuracoes/tipos_carga_spe", permission: "tipos_carga_spe" },
      { title: "Validação CRLV", path: "/patio/configuracoes/validacao_crlv", permission: "validacao_crlv" },
    ],
  },
  {
    title: "Indicadores",
    icon: "BarChart",
    submenu: [
      { title: "Power BI", path: "/patio/indicadores/powerbi", permission: "power_bi" },
    ],
  },
];

/**
 * Identifica um usuário de transportadora.
 *
 * O campo `grupo` guarda o NOME do grupo (ex.: "TRANSPORTADORA XPTO"), e não o
 * subsistema, então comparar com a string "TRANSPORTADORA" deixava passar a
 * maioria dos usuários de transportadora para o menu do pátio. O vínculo
 * confiável é o `id_transportadora` gravado no login.
 */
export const isCarrierUser = (
  user?: { grupo?: string; id_transportadora?: number | null } | null
): boolean =>
  Boolean(user?.id_transportadora) || user?.grupo?.toUpperCase() === "TRANSPORTADORA";
